export default function getBaseUrl() {
    return "https://api.circled7.com/";
}